import React from 'react';
import { translate } from '../../../Services/translation';
import clsx from 'clsx';

const OrderListItemMobile = ({ order, onClick, onClickApprove }) => {
  return (
    <li
      className={clsx(
        'p-4',
        'border',
        'border-solid',
        'border-gray-300',
        'rounded',
        'bg-white',
        'mb-4'
      )}
    >
      <p className={clsx('text-lg', 'font-bold', 'mb-3')}>
        {translate('orderlist.column.ordernumber')}:{' '}
        {order.externalOrderID}
      </p>
      <div className={clsx('grid', 'grid-cols-2')}>
        <div className={clsx('flex', 'flex-col')}>
          <p className={clsx('text-sm', 'uppercase', 'text-gray-600')}>
            {translate('orderlist.column.quantity')}
          </p>
          <p className={clsx('text-md')}>{order.orderRows.length}</p>
        </div>
        <div className={clsx('flex', 'flex-col')}>
          <p className={clsx('text-sm', 'uppercase', 'text-gray-600')}>
            {translate('orderlist.column.grandtotal')}
          </p>
          <p className={clsx('text-md')}>{order.orderGrandTotal}</p>
        </div>
        <div className={clsx('flex', 'flex-col')}>
          <p className={clsx('text-sm', 'uppercase', 'text-gray-600')}>
            {translate('orderlist.column.orderdate')}
          </p>
          <p className={clsx('text-md')}>{order.orderDate}</p>
        </div>
        <div className={clsx('flex', 'flex-col')}>
          <p className={clsx('text-sm', 'uppercase', 'text-gray-600')}>
            {translate('orderlist.column.status')}
          </p>
          <p className={clsx('text-md')}>{order.status}</p>
        </div>
      </div>
      <div className="mt-3 flex items-center gap-2">
        <button
          onClick={() => onClick && onClick(order)}
          className={clsx(
            'btn',
            'btn--outline',
            'btn--small',
            'col-span-2',
            'mt-3',
            'font-bold',
            'md:col-span-1',
            'md:mt-0',
            'flex-1'
          )}
        >
          {translate('orderlist.column.readmore')}
        </button>
        <button
          onClick={() => onClickApprove && onClickApprove(order)}
          className={clsx(
            'btn',
            'btn--primary',
            'btn--small',
            'col-span-2',
            'mt-3',
            'font-bold',
            'md:col-span-1',
            'md:mt-0',
            'flex-1'
          )}
        >
          {translate('orderapproverlist.column.approve')}
        </button>
      </div>
    </li>
  );
};

export default OrderListItemMobile;
